<template>
 <v-container>
 
<v-row>
  <v-col cols="12" md="6">
    <RegisterView newRoute="/waizmanntabellen_bestellen" v-if="!userData" />
  </v-col>
  <v-col cols="12" md="3" v-if="baseStore.isDesktop">

    <v-row  v-if="userData">
    <v-col cols="12" md="12">
      <h2><router-link class="yesLink" to="/waizmanntabellen_bestellen">Sie sind jetzt eingeloggt - klicken Sie hier um WaizmannTabellen anzufordern</router-link></h2>
    </v-col>
  </v-row>
  <v-row  class="mb-4"  v-if="!userData">
    <v-col cols="12" md="12">

      <img
          :src="require('@/assets/bestellung/aufstellerPremium.png')"
          style="width: 240px; float: left"
        />
        <img
          :src="require('@/assets/bestellung/auftstellerPremiumPzr.png')"
          style="width: 240px; float: left"
        />
    </v-col>
  

  </v-row>
  
  </v-col>

</v-row>
  
  </v-container>
</template>

<script setup>
import {  onMounted,inject } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/userStore';




const baseStore = inject('baseStore')
const updateDocumentHead = inject('updateDocumentHead');


import RegisterView from '@/components/objects/user/RegisterView.vue'
const userStore = useUserStore();


const { userData } = storeToRefs(userStore)
const dataplugin = inject('dataplugin');




onMounted(() => {
  if (dataplugin) {
    console.log('Plugin-Daten:', dataplugin);
    console.log('Zahnarzt-Wert:', dataplugin.zahnarzt);
  } else {
    console.error('dataplugin ist nicht verfügbar!');
  }

    updateDocumentHead(
      'TeamWaizmann | WaizmannTabellen anfordern',
      'TeamWaizmann | WaizmannTabellen anfordern'
    ) 
  


})
</script>
